import { urls as u } from '../../config/config.json';

const hostname = window.location.hostname || '';
export const isBeta = hostname.startsWith('beta') || hostname.startsWith('local') || hostname.startsWith('127.');
export const apiUrl = isBeta ? u.API_URL_BETA : u.API_URL;
export const pmApiUrl = isBeta ? u.PM_API_URL_BETA : u.PM_API_URL;
export const patchApiUrl = u.PATCH_API_URL;
export const staticSeUrl = u.STATIC_SE_URL;



// WEBPACK FOOTER //
// ./src/api/config.ts